import classNames from "./SupportDialog.module.css";
import RadixDialog from "./RadixDialog";
import { NeedHelp } from "../../routes/home/Support";

function SupportDialog(props: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <RadixDialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title={"Support"}
      content={<NeedHelp />}
      className={classNames.SupportDialog}
    />
  );
}

export default SupportDialog;
